module.exports = "https://bt2-static.vkplay.ru/promo/event/img/logo.404454ad.svg";